((Drupal, once, $) => {
  Drupal.behaviors.accordionBehavior = {
    attach(context) {
      const accordionTitles = once('accordion', '.accordion-title', context);
      accordionTitles.forEach((title) => {
        $(title).on('click', function () {
          const isActive = $(this).hasClass('active');

          // Close all tabs
          $('.accordion-title').removeClass('active');
          $('.accordion-content').slideUp(200);

          if (!isActive) {
            // If not already active, open this one
            $(this).addClass('active');
            $(this).next('.accordion-content').slideDown(200);
          }
          // If it was active, it's now closed, and nothing opens (toggle behavior)
        });
      });
    }
  };
})(Drupal, once, jQuery);

